export const MODES = {
    private: {
        id: "private",
        label: "Private Room",
        description: "Invite-code room. Bring your own rules.",
        minPlayers: 1,
        maxPlayers: 8,
        botFillAfterMs: 0,
        ranked: false,
    },
    bots: {
        id: "bots",
        label: "Practice vs CPU",
        description: "Spawn AI opponents to practice. Unranked.",
        minPlayers: 1,
        maxPlayers: 8,
        botFillAfterMs: 0,
        ranked: false,
        preloadedBots: 2,
    },
    custom: {
        id: "custom",
        label: "Custom Lobby",
        description: "Public custom lobby. Host picks the rules.",
        minPlayers: 2,
        maxPlayers: 8,
        botFillAfterMs: 0,
        ranked: false,
    },
};
export const ALL_MODES = ["custom", "private", "bots"];
export const BOT_DIFFICULTIES = ["easy", "normal", "hard", "nightmare"];
export const BOT_DIFFICULTY_SPECS = {
    easy: {
        id: "easy",
        label: "Easy",
        aimErrorDeg: 12,
        powerErrorFrac: 0.2,
        weaponPool: ["shell"],
        mmr: 900,
    },
    normal: {
        id: "normal",
        label: "Normal",
        aimErrorDeg: 6,
        powerErrorFrac: 0.1,
        weaponPool: ["shell", "heavy", "skipper"],
        mmr: 1200,
    },
    hard: {
        id: "hard",
        label: "Hard",
        aimErrorDeg: 2.5,
        powerErrorFrac: 0.04,
        weaponPool: ["shell", "heavy", "cluster", "grenade", "mirv"],
        mmr: 1500,
    },
    nightmare: {
        id: "nightmare",
        label: "Nightmare",
        aimErrorDeg: 0.8,
        powerErrorFrac: 0.02,
        weaponPool: ["heavy", "cluster", "airstrike", "mirv"],
        mmr: 1800,
    },
};
export function isGameMode(x) {
    return typeof x === "string" && x in MODES;
}
//# sourceMappingURL=modes.js.map